import _ from 'lodash';

export const doesRoleHaveAccessToFeature = (customAccess, urlsNeededForFeature, doesRequireAllUrls = false) => {
    if (!customAccess) {
        return true;
    }

    return _.reduce(urlsNeededForFeature, (doesHaveAccessToFeature, serviceUrlsNeededForFeature, serviceArnNeededForFeature) => {
        const customAccessUrls = _.get(customAccess, serviceArnNeededForFeature);

        if (_.isEmpty(customAccessUrls)) {
            return false;
        }

        const featureUrlsRoleHasAccessTo = _.intersectionBy(serviceUrlsNeededForFeature, customAccessUrls, _.toLower);

        if (_.isEmpty(featureUrlsRoleHasAccessTo)) {
            return false;
        }

        if (doesRequireAllUrls) {
            if (!doesHaveAccessToFeature) {
                return false;
            }
            const missingUrls = _.difference(serviceUrlsNeededForFeature, featureUrlsRoleHasAccessTo);

            return _.isEmpty(missingUrls);
        } else if (!doesHaveAccessToFeature) {
            return !_.isEmpty(featureUrlsRoleHasAccessTo);
        } else {
            return doesHaveAccessToFeature;
        }
    }, true);
};
